import { useState } from 'react';
import { ADMIN_EXECUTIVE_ID, ADMIN_MANAGER_ID } from '../utils/constant';
import { BILL_DATE_ERROR, BILL_DATE_RANGE_ERROR, CGST_ERROR, DEPARTMENT_ERROR, GST_FIELD_REQUIRED_ERROR, IGST_ERROR, ITEM_ERROR, MIN_QUANTITY_ERROR, MIN_RATE_ERROR, QUANTITY_ERROR, RATE_ERROR, SGST_ERROR, SUBTOTAL_ERROR, UPLOAD_DOCUMENT_ERROR, UPLOAD_MAX_FILE_ERROR, UPLOAD_MAX_SIZE_ERROR, UPLOAD_PDF_ERROR, UTGST_ERROR, VALID_FORMAT_ERROR } from '../utils/helpers/globalErrorMessage';
import moment from 'moment';

const EditIndividuallBillValidation = () => {
    const [errors, setErrors] = useState({});

    const isValidFileType = (file) => {
        const allowedTypes = ["application/pdf"];
        return allowedTypes.includes(file.type);
    };

    const MAX_FILE_SIZE = 2 * 1024 * 1024;

    const isValidDateFormat = (dateStr) => {
        const regex = /^\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])$/;
        return regex.test(dateStr);
    };

    const validateForm = (roleId, departmentId, billDate, itemDescription, subTotal, cgst, sgst, utgst, igst, lineLevelCheck, oldFiles, individualBillDocument) => {
        let errors = {};
        errors.itemDescription = []
        let formIsValid = true;

        if (roleId === ADMIN_MANAGER_ID || roleId === ADMIN_EXECUTIVE_ID) {
            if (!departmentId) {
                formIsValid = false;
                errors.departmentId = DEPARTMENT_ERROR;
            }
        }
        if (!billDate) {
            formIsValid = false;
            errors.billDate = BILL_DATE_ERROR;
        } else if (!isValidDateFormat(billDate)) {
            formIsValid = false;
            errors.billDate = VALID_FORMAT_ERROR;
        } else {
            const minAllowedDate = moment().subtract(1, 'months');
            const selectedDate = moment(billDate);
            if (selectedDate.isBefore(minAllowedDate, 'day')) {
                formIsValid = false;
                errors.billDate = BILL_DATE_RANGE_ERROR;
            }
        }

        if (!lineLevelCheck) {
            itemDescription.forEach((item, index) => {
                const lineItemErrors = {};

                if (!item.ItemId) {
                    formIsValid = false;
                    lineItemErrors.ItemId = ITEM_ERROR;
                }
                if (!item.Rate) {
                    formIsValid = false;
                    lineItemErrors.Rate = RATE_ERROR;
                }
                if (item.Rate && item.Rate == 0) {
                    formIsValid = false;
                    lineItemErrors.Rate = MIN_RATE_ERROR;
                }
                if (!item.Quantity) {
                    formIsValid = false;
                    lineItemErrors.Quantity = QUANTITY_ERROR;
                }
                if (item.Quantity && item.Quantity == 0) {
                    formIsValid = false;
                    lineItemErrors.Quantity = MIN_QUANTITY_ERROR;
                }
                if (Object.keys(lineItemErrors).length > 0) {
                    errors.itemDescription[index] = lineItemErrors;
                }
                return lineItemErrors;
            });

            if (errors.itemDescription.length === 0) {
                delete errors.itemDescription;
            }
        }
        else {
            itemDescription.forEach((item, index) => {
                const lineItemErrors = {};

                if (!item.ItemId) {
                    formIsValid = false;
                    lineItemErrors.ItemId = ITEM_ERROR;
                }
                if (!item.Rate) {
                    formIsValid = false;
                    lineItemErrors.Rate = RATE_ERROR;
                }
                if (item.Rate && item.Rate == 0) {
                    formIsValid = false;
                    lineItemErrors.Rate = MIN_RATE_ERROR;
                }
                if (!item.Quantity) {
                    formIsValid = false;
                    lineItemErrors.Quantity = QUANTITY_ERROR;
                }
                if (item.Quantity && item.Quantity == 0) {
                    formIsValid = false;
                    lineItemErrors.Quantity = MIN_QUANTITY_ERROR;
                }
                const hasGST = item.cgst || item.sgst || item.utgst || item.igst;
                if (!hasGST) {
                    formIsValid = false;
                    lineItemErrors.cgst = CGST_ERROR;
                    lineItemErrors.sgst = SGST_ERROR;
                    lineItemErrors.utgst = UTGST_ERROR;
                    lineItemErrors.igst = IGST_ERROR;
                }
                if (item.cgst && !item.sgst) {
                    formIsValid = false;
                    lineItemErrors.sgst = SGST_ERROR;
                }
                if (!item.cgst && item.sgst) {
                    formIsValid = false;
                    lineItemErrors.cgst = CGST_ERROR;
                }
                if (Object.keys(lineItemErrors).length > 0) {
                    errors.itemDescription[index] = lineItemErrors;
                }
                return lineItemErrors;
            });

            if (errors.itemDescription.length === 0) {
                delete errors.itemDescription;
            }
        }

        if (subTotal === 0) {
            formIsValid = false;
            errors.subTotal = SUBTOTAL_ERROR;
        }

        if (!lineLevelCheck) {
            if ((cgst === null || cgst === '') && (sgst === null || sgst === '') && (utgst === null || utgst === '') && (igst === null || igst === '')) {
                formIsValid = false;
                errors.tax = GST_FIELD_REQUIRED_ERROR;
            }
            else if (cgst && (sgst === null || sgst === '')) {
                formIsValid = false;
                errors.tax = SGST_ERROR;
            }
            else if ((cgst === null || cgst === '') && sgst) {
                formIsValid = false;
                errors.tax = CGST_ERROR;
            }
        }

        if (oldFiles.length === 0) {
            if (individualBillDocument.length === 0) {
                formIsValid = false;
                errors.files = UPLOAD_DOCUMENT_ERROR;
            }
            else {
                for (const item of individualBillDocument) {
                    if (!isValidFileType(item)) {
                        formIsValid = false;
                        errors.files = UPLOAD_PDF_ERROR;
                        break;
                    }
                    if (item.size > MAX_FILE_SIZE) {
                        formIsValid = false;
                        errors.files = UPLOAD_MAX_SIZE_ERROR;
                        break;
                    }
                    if (individualBillDocument.length > 5) {
                        formIsValid = false;
                        errors.files = UPLOAD_MAX_FILE_ERROR;
                        break;
                    }
                }
            }
        }
        else {
            for (const item of individualBillDocument) {
                if (!isValidFileType(item)) {
                    formIsValid = false;
                    errors.files = UPLOAD_PDF_ERROR;
                    break;
                }
                if (item.size > MAX_FILE_SIZE) {
                    formIsValid = false;
                    errors.files = UPLOAD_MAX_SIZE_ERROR;
                    break;
                }
                if (individualBillDocument.length + oldFiles.length > 5) {
                    formIsValid = false;
                    errors.files = UPLOAD_MAX_FILE_ERROR;
                    break;
                }
            }
        }

        setErrors(errors);
        return formIsValid;
    };

    return { errors, setErrors, validateForm };
};

export default EditIndividuallBillValidation;
